module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10029.7c1d081f.jpg";